import AvailableTenanciesList from './AvailableTenanciesList';

export default AvailableTenanciesList;